<div class="card">
    <div class="card-body">
        <h5 class="card-title">Before You Get Started</h5>
        <ul class="mb-0">
            <li>A one-time brand registration fee of $4 will be charged to your account once you agree and submit the A2P Registration form.</li>
            <li>Please ensure that the information you enter in the A2P Registration form is accurate and complete so that it is processed swiftly.</li>
            <li>The approval process is managed by a third-party; not Tinsel CRM.</li>
        </ul>
    </div>
</div>
<div class="mt-2">
    <div class="card">
        <div class="card-header d-flex">
            <h5 class="my-auto">A2P Registration</h5>
            <button type="button" class="btn btn-primary ms-auto" [ngbPopover]="a2pDescription" triggers="click" autoClose="outside" #a2pDescriptionPopOver="ngbPopover">
                <fa-icon [icon]="faQuestion"></fa-icon>
            </button>
        </div>
        @if (subAccountDetails.customerProfile) {
        <div class="card-body">
            <div class="bs-stepper" #a2pRegistrationStepperRef>
                <div class="bs-stepper-header">
                    <div class="step" data-target="#business-form">
                        <button class="step-trigger">
                            <span class="bs-stepper-circle">1</span>
                            <span class="bs-stepper-label">Business Information</span>
                        </button>
                    </div>
                    <div class="line"></div>
                    <div class="step" data-target="#contact-form">
                        <button class="step-trigger" [disabled]="!subAccountDetails?.customerProfile?.businessInformation">
                            <span class="bs-stepper-circle">2</span>
                            <span class="bs-stepper-label">Authorized Representative</span>
                        </button>
                    </div>
                    <div class="line"></div>
                    <div class="step" data-target="#address-form">
                        <button class="step-trigger" [disabled]="!subAccountDetails?.customerProfile?.authorizedRepresentative">
                            <span class="bs-stepper-circle">3</span>
                            <span class="bs-stepper-label">Business Address</span>
                        </button>
                    </div>
                    <div class="line"></div>
                    <div class="step" data-target="#review-form">
                        <button class="step-trigger" [disabled]="!subAccountDetails?.customerProfile?.businessAddress">
                            <span class="bs-stepper-circle">4</span>
                            <span class="bs-stepper-label">Summary and Agreement</span>
                        </button>
                    </div>
                </div>
                <div class="bs-stepper-content">
                    <div id="number" class="content">
                        <ng-container [ngTemplateOutlet]="numberStep"></ng-container>
                    </div>
                    <div id="business-form" class="content">
                        <app-a2p-registration-business-information (proceedToNextStep)="nextStep();" [businessInformation]="subAccountDetails?.customerProfile?.businessInformation"></app-a2p-registration-business-information>
                    </div>
                    <div id="contact-form" class="content">
                        <app-a2p-registration-authorized-representative (proceedToNextStep)="nextStep();" [authorizedRepresentative]="subAccountDetails?.customerProfile?.authorizedRepresentative"></app-a2p-registration-authorized-representative>
                    </div>
                    <div id="address-form" class="content">
                        <app-a2p-registration-business-address (proceedToNextStep)="nextStep();" [businessAddress]="subAccountDetails?.customerProfile?.businessAddress"></app-a2p-registration-business-address>
                    </div>
                    <div id="review-form" class="content">
                        <ng-container [ngTemplateOutlet]="agreement"></ng-container>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
</div>

<ng-template #a2pDescription>
    <p class="mb-0">
        A2P registration is a verification process that US mobile phone carriers require to ensure that text
        messages sent from businesses to customers are legitimate. A2P stands for “application to phone,” meaning that
        this registration is intended for businesses that use software to send bulk SMS texts to their audience. Because
        most, if not all, companies probably use a text marketing platform (aka the “software”) to reach individuals
        through this channel, A2P registration applies in most cases.
    </p>
</ng-template>

<ng-template #agreement>
    <div class="d-flex flex-column">
        <p>
            I hereby consent to the collection, use, and sharing of the information
            provided in this application for the purpose of processing and vetting for A2P (Application-to-Person)
            registration. I understand that this process may include background checks and other necessary verification
            steps. Furthermore, I acknowledge that Tinsel CRM is not liable for the approval or denial of my
            application.
        </p>
        <button type="button" class="btn btn-primary" (click)="submitForReview();">Agree and Submit Application</button>
    </div>
</ng-template>